
import { Container } from '@mui/material';


export default function GestDirectorTecnico({ element: component, ...rest }) {
    // const classes = useStyles()

    return (<Container>{component}</Container>)
}